import { c as _c } from "react/compiler-runtime";
import { Link } from "react-router";
export function NotFoundPage() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="container mx-auto p-8 text-center relative z-10"><h1 className="text-2xl font-bold mb-2">404</h1><p className="text-muted-foreground mb-4">That route doesn't exist.</p><Link to="/" className="underline">Back home</Link></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}